import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as GlobalStore from 'Store/actions/enhancers';
import PortalDrawer from './PortalDrawer';
import { doMenuClick } from '../../store/actions/analytics';
import { nullSafe } from 'Utility/globalMethods';

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(GlobalStore, dispatch),
  doAnalyticsMenuClick: (payload) => dispatch(doMenuClick(payload)),
});

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => ({ ...stateProps, ...ownProps, actions: dispatchProps }),
)(PortalDrawer);
